import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import type { WithBoundArgs } from '@glint/template';

import PrismTabsContainerTabContent from './tab-content.gts';

interface PrismTabsContainerContentSignature {
  Args: {
    activeTabId: string;
  };
  Blocks: {
    default: [
      {
        tab: WithBoundArgs<typeof PrismTabsContainerTabContent, 'activeTabId'>;
      },
    ];
  };
}

const PrismTabsContainerContent = <template>
  <div class="prism-tabs-container__content">
    {{yield
      (hash
        tab=(component PrismTabsContainerTabContent activeTabId=@activeTabId)
      )
    }}
  </div>
</template> satisfies TOC<PrismTabsContainerContentSignature>;

export default PrismTabsContainerContent;
